import { connect } from "react-redux";

import { actions as alertsActions } from "./Alerts.redux";
import { actions as compareActions } from "../compare";

import Alerts from "./Alerts.view";

const mapStateToProps = state => ({
  authenticated: !!state.login.auth.expires,
  alerts: state.alerts,
  alertsError: state.alertsError,
  alertsLoading: state.alertsLoading,
  alertsDetails: state.alertsDetails,
  alertsDetailsError: state.alertsDetailsError,
  alertsDetailsLoading: state.alertsDetailsLoading,
  comparedListings: state.comparedListings,
  targetDevice: state.targetDevice,
  userWatchedListings: state.login.userWatchedListings,
});

const mapDispatchToProps = dispatch => ({
  addToComparedListings: listing => dispatch(compareActions.add(listing)),
  clearAlertsDetailsError: () =>
    dispatch(alertsActions.handleAlertsDetailsError(null)),
  fetchAlerts: () => dispatch(alertsActions.fetchAlerts()),
  fetchAlertsDetails: id => dispatch(alertsActions.fetchAlertsDetails(id)),
  removeFromComparedListings: equipmentId =>
    dispatch(compareActions.remove(equipmentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
